import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { allUserKycType, TypeUserKyc } from "@domain/userKyc/userKyc";
import { mobile } from "@ui/styles/utils";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { Row, row } from "@ui/components/layout";
import { USER_TYPE_INFOS } from "./userTypeInfos";

interface UserSelectorProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onClick"> {
	value?: TypeUserKyc;
	onClick: (value: TypeUserKyc) => void;
}

export const UserSelector: React.FC<UserSelectorProps> = ({ onClick, value, ...htmlProps }) => {
	const current = allUserKycType.find((item) => item === value);
	return (
		<Container {...htmlProps}>
			{allUserKycType.map((type) => (
				<Item selected={current === type} key={type} onClick={() => onClick(type)}>
					<Row gap={5} align="center" justify="center">
						<img src={USER_TYPE_INFOS[`${type}`]} />
						<StyledPrimaryMedium selected={current === type}>{I18n.t(`kyc.edit.${type}.title`)}</StyledPrimaryMedium>
					</Row>
				</Item>
			))}
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	${row(20, "center", "center")}
`;

const Item = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "selected",
})<{ selected: boolean }>`
	flex: 1;
	cursor: pointer;
	border: 1px solid ${({ theme, selected }) => (selected ? theme.colors.secondary : "#dee9fe")};
	border-radius: 12px;
	padding: 20px 30px;
	@media ${mobile} {
		padding: 10px 15px;
		> img {
			margin-right: 0;
		}
	}
`;
const StyledPrimaryMedium = styled(PrimaryMedium).withConfig({
	shouldForwardProp: (prop) => prop !== "selected",
})<{ selected: boolean }>`
	color: ${({ theme, selected }) => selected && theme.colors.secondary};
	@media ${mobile} {
		font-size: 0.7rem;
	}
`;
